import { DiPython, DiJava, DiJavascript1, DiDjango } from "react-icons/di";
import { SiSpring, SiSpringboot, SiApachemaven, SiFastapi } from "react-icons/si"
import { FaGitAlt } from "react-icons/fa"

export default [
  {
    component: <DiJava />,
    link: "https://www.java.com/en/a",
    color: "#3a75b0"
  },
  {
    component: <DiPython />,
    link: "https://www.python.org",
    color: "yellow"
  },
  {
    component: <DiJavascript1 />,
    link: "https://www.javascript.com",
    color: "yellow"
  },
  {
    component: <SiSpring />,
    link: "https://spring.io/",
    color: "green"
  },
  {
    component: <SiSpringboot />,
    link: "https://spring.io/projects/spring-boot",
    color: "green"
  },
  {
    component: <DiDjango />,
    link: "https://www.djangoproject.com/",
    color: "#0C4B33"
  },
  {
    component: <SiFastapi />,
    link: "https://fastapi.tiangolo.com",
    color: "#009485"
  },
  {
    component: <FaGitAlt />,
    link: "https://git-scm.com/",
    color: "#f14e32"
  },
  {
    component: <SiApachemaven />,
    link: "https://maven.apache.org/",
    color: "#cc2336"
  },
];
